import React from "react";
import { connect } from "react-redux";

import axios from "../../axios-atis";

import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { fetchUsers, fetchCompanies } from "../../store/actions/index";
import ReactTable from "../../react-table-atis";
import { isA } from "../../store/utility";

import { Row, Col, Button } from "react-bootstrap";
import { Tooltip } from "react-tippy";
import UserModal from "../Modal/UserModal";
import NewUserModal from "../Modal/NewUserModal";

class UserList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: true,
      pages: null,
      page: 0,
      pageSize: 20,
      sorted: null,
      filtred: null,
      showUserModal: false,
      showNewUserModal: false,
      selectedRow: null,
      sections: [],
      companies: [],
      company: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.loading &&
      !nextProps.loading &&
      nextProps.users &&
      nextProps.companies &&
      null == nextProps.error
    ) {
      this.setState({
        loading: nextProps.loading,
        pages: nextProps.users.length,
        data: nextProps.users,
        companies: nextProps.companies,
        company: nextProps.company
      });
    }
  }

  componentDidMount() {
    if (isA()) {
      this.props.dispatch(fetchCompanies);
    }
    this.props.dispatch(
      fetchUsers(
        this.state.page,
        this.state.pageSize,
        this.state.sorted,
        this.state.filtred
      )
    );
  }

  editUserHandler = (e, row) => {
    e.preventDefault();
    this.setState({
      selectedRow: row.original,
      showUserModal: true
    });
  };
  newUserHandler = e => {
    e.preventDefault();
    this.setState({
      selectedRow: null,
      showNewUserModal: true
    });
  };

  closeUserModal = () => {
    this.setState({
      showUserModal: false
    });
  };

  closeNewUserModal = () => {
    this.setState({
      showNewUserModal: false
    });
  };

  renderTable = () => {
    return (
      <ReactTable
        columns={[
          { Header: "Login", accessor: "username" },
          { Header: "Prénom", accessor: "forname" },
          { Header: "Nom", accessor: "name" },
          { Header: "Société", accessor: "company" },
          { Header: "Site", accessor: "section" },
          { Header: "E-mail", accessor: "email", filterable: false },
          { Header: "Téléphone", accessor: "cellular", filterable: false },
          {
            Header: "",
            accessor: "appKey",
            filterable: false,
            width: 32,
            Cell: row => (
              <div style={{ width: "100%", textAlign: "center" }}>
                {row.value != null && row.value.length > 0 ? (
                  <span class="fa fa-key" />
                ) : null}
              </div>
            )
          },
          {
            Header: "",
            accessor: "id",
            filterable: false,
            width: 32,
            Cell: row => (
              <div
                style={{ width: "100%", textAlign: "center" }}
                onClick={e => this.editUserHandler(e, row)}
              >
                <Tooltip
                  title={"Éditer l'utilisateur " + row.original.username}
                  position="bottom"
                >
                  <span className="fa fa-edit" />
                </Tooltip>
              </div>
            )
          }
        ]}
        filterable
        sortable
        data={this.state.data}
        loading={this.state.loading}
        className="-striped -highlight"
      />
    );
  };

  render() {
    const { error } = this.props;
    if (error) {
      return <div>Erreur : {error.message}</div>;
    }
    return (
      <div className="content-wrapper">
        <Row className="form-group content-heading">
          <Col md={8}>Utilisateurs</Col>
          <Col md={4}>
            <Button
              bsStyle="primary"
              className="pull-right"
              onClick={e => this.newUserHandler(e)}
            >
              <span className="fa fa-user-plus" />
              &nbsp;Nouvel utilisateur
            </Button>
          </Col>
        </Row>

        {this.renderTable()}
        <UserModal
          show={this.state.showUserModal}
          onHide={this.closeUserModal.bind(this)}
          data={this.state.selectedRow}
        />
        <NewUserModal
          show={this.state.showNewUserModal}
          onHide={this.closeNewUserModal.bind(this)}
          data={this.state.companies}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    users: state.user.users,
    error: state.user.error,
    loading: state.user.loading && state.company.loading,
    userId: state.auth.userId,
    isAuthenticated: state.auth.token !== null,
    companies: state.company.companies,
    company: state.auth.company
  };
};

export default connect(mapStateToProps)(withErrorHandler(UserList, axios));



// WEBPACK FOOTER //
// ./src/containers/User/UserList.js